export const COLLECTION = {
  camper: {
    open: [
      "ready_made_feature_camper_open_0",
      "ready_made_feature_camper_open_1",
      "ready_made_feature_camper_open_2",
    ],
    closed: [
      "ready_made_feature_camper_closed_0",
      "ready_made_feature_camper_closed_1",
      "ready_made_feature_camper_closed_2",
    ],
  },
  boat: {
    open: [
      "ready_made_feature_boat_open_0",
      "ready_made_feature_boat_open_1",
      "ready_made_feature_boat_open_2",
    ],
    closed: [
      "ready_made_feature_boat_closed_0",
      "ready_made_feature_boat_closed_1",
      "ready_made_feature_boat_closed_2",
    ],
  },
  trike: {
    open: [
      "ready_made_feature_trike_open_0",
      "ready_made_feature_trike_open_1",
      "ready_made_feature_trike_open_2",
    ],
    closed: [
      "ready_made_feature_trike_closed_0",
      "ready_made_feature_trike_closed_1",
      "ready_made_feature_trike_closed_2",
    ],
  },
}

export const FEATURES = {
  f01: {
    img: "f01",
    title: "",
    description: "Handlebars with 2 riding positions. Motor display & controls. Gears shifter, hydraulic brake levers. Lights, honk, turn indicator switches.",
  },
  f02: {
    img: "f02",
    title: "",
    description: "Hydraulic brake lever with parking lock. Motor throttle. Lights, honk, turn indicator switches.",
  },
  f03: {
    img: "f03",
    title: "",
    description: "Two USB charging ports.",
  },
  f04: {
    img: "f04",
    title: "",
    description: "Adjustable trike seat.",
  },
  f05: {
    img: "f05",
    title: "",
    description: "7 gears internal gear hub & 1000W electric motor.",
  },
  f06: {
    img: "f06",
    title: "",
    description: "1000W electric trike motor.",
  },
  f07: {
    img: "f07",
    title: "",
    description: "Hydraulic disc brakes.",
  },
  f08: {
    img: "f08",
    title: "",
    description: "Front badge & lights.",
  },
  f09: {
    img: "f09",
    title: "",
    description: "Pull the knob and lift the rear wheels up.",
  },
  f10: {
    img: "f10",
    title: "",
    description: "24” rear wheels with side covers.",
  },
  f11: {
    img: "f11",
    title: "",
    description: "24” rear wheels with suspension and hydraulic disc brakes.",
  },
  f12: {
    img: "f12",
    title: "",
    description: "Foot pegs to help getting up / in.",
  },
  f13: {
    img: "f13",
    title: "",
    description: "Marker lights.",
  },
  f14: {
    img: "f14",
    title: "",
    description: "Lit number plate.",
  },
  f15: {
    img: "f15",
    title: "",
    description: "Battery charging socket with 220V cable.",
  },
  f16: {
    img: "f16",
    title: "",
    description: "Passenger seat with seat belt and cup / bottle holders.",
  },
  f17: {
    img: "f17",
    title: "",
    description: "Cup / bottle holder.",
  },
  f18: {
    img: "f18",
    title: "",
    description: "Inflatable stabilizers.",
  },
  f19: {
    img: "f19",
    title: "",
    description: "Attachable / optional oars.",
  },
  f20: {
    img: "f20",
    title: "",
    description: "Tilting 1150W boat motor.",
  },
  f21: {
    img: "f21",
    title: "",
    description: "Boat dashboard with removable steering wheel, display, USB charging, honk, lights, power & mode switches.",
  },
  f22: {
    img: "f22",
    title: "",
    description: "Front headlight.",
  },
  f23: {
    img: "f23",
    title: "",
    description: "Windshield wiper.",
  },
  f24: {
    img: "f24",
    title: "",
    description: "Latches to close sliding hatch.",
  },
  f25: {
    img: "f25",
    title: "",
    description: "Two adjustable seats.",
  },
  f26: {
    img: "f26",
    title: "",
    description: "Storage units for essential items.",
  },
  f27: {
    img: "f27",
    title: "",
    description: "Built-in radio with Bluetooth connection.",
  },
  f28: {
    img: "f28",
    title: "",
    description: "Fits two people.",
  },
  f29: {
    img: "f29",
    title: "",
    description: "Folding table where a camping stove can be placed along with 2 cups. Worktop can be used for cooking, working, watching a movie, etc.",
  },
  f30: {
    img: "f30",
    title: "",
    description: "Interior view of the hatch.",
  },
  f31: {
    img: "f31",
    title: "",
    description: "Easy access to luggage.",
  },
  f32: {
    img: "f32",
    title: "",
    description: "Removable plant pot & integrated solar panels.",
  },
}

export const FEATURE_MAP = {
  "ready_made_feature_trike_closed_0": [
    {
      tag: 'f01',
      x: 240,
      y: 69,
      data: FEATURES.f01,
    },
    {
      tag: 'f05',
      x: 272, y: -128,
      data: FEATURES.f05,
    },
    {
      tag: 'f15',
      x: 87, y: -83,
      data: FEATURES.f15,
    },
    {
      tag: 'f10',
      x: 7, y: -147,
      data: FEATURES.f10,
    },
    {
      tag: 'f11',
      x: -65, y: -197,
      data: FEATURES.f11,
    },
    {
      tag: 'f14',
      x: -284, y: -91,
      data: FEATURES.f14,
    },
    {
      tag: 'f24',
      x: -230, y: -1,
      data: FEATURES.f24,
    },
    {
      tag: 'f23',
      x: -150, y: 58,
      data: FEATURES.f23,
    },
    {
      tag: 'f22',
      x: -189, y: 132,
      data: FEATURES.f22,
    },
    {
      tag: 'f32',
      x: -56, y: 160,
      data: FEATURES.f32,
    },
    { tag: 'f13', x: -68, y: -10, data: FEATURES.f13, desktoponly: true, },
    { tag: 'f09', x: -50, y: -130, data: FEATURES.f09, desktoponly: true, },
    { tag: 'f12', x: 129, y: -142, data: FEATURES.f12, desktoponly: true, },
  ],
  "ready_made_feature_trike_open_0": [
    {
      tag: 'f01',
      x: 240,
      y: 69,
      data: FEATURES.f01,
    },
    {
      tag: 'f05',
      x: 272, y: -128,
      data: FEATURES.f05,
    },
    { tag: 'f12', x: 120, y: -144, data: FEATURES.f12, },
    {
      tag: 'f14',
      x: -284, y: -91,
      data: FEATURES.f14,
    },
    { tag: 'f09', x: -45, y: -150, data: FEATURES.f09, },
    { tag: 'f30', x: -54, y: 73, data: FEATURES.f30, },
    { tag: 'f13', x: 56, y: -10, data: FEATURES.f13, },
    { tag: 'f32', x: 66, y: 159, data: FEATURES.f32, },
    { tag: 'f22', x: -73, y: 140, data: FEATURES.f22, desktoponly: true, },
    { tag: 'f23', x: -189, y: 67, data: FEATURES.f23, desktoponly: true, },
    { tag: 'f10', x: 8, y: -149, data: FEATURES.f10, desktoponly: true, },
    { tag: 'f11', x: -38, y: -204, data: FEATURES.f11, desktoponly: true, },
    { tag: 'f15', x: 79, y: -73, data: FEATURES.f15, desktoponly: true, },
  ],
  "ready_made_feature_boat_closed_0": [
    { tag: 'f01', x: 180, y: 96, data: FEATURES.f01, },
    { tag: 'f18', x: 89, y: -119, data: FEATURES.f18, },
    { tag: 'f19', x: -8, y: -93, data: FEATURES.f19, },
    { tag: 'f32', x: -48, y: 175, data: FEATURES.f32, },
    { tag: 'f23', x: -144, y: 56, data: FEATURES.f23, },
    { tag: 'f22', x: -193, y: 127, data: FEATURES.f22, },
    { tag: 'f14', x: -298, y: -93, data: FEATURES.f14, },
    { tag: 'f24', x: -239, y: -13, data: FEATURES.f24, },
    { tag: 'f21', x: -188, y: -26, data: FEATURES.f21, desktoponly: true, },
    { tag: 'f13', x: -87, y: -10, data: FEATURES.f13, desktoponly: true, },
  ],
  "ready_made_feature_boat_open_0": [
    { tag: 'f01', x: 169, y: 100, data: FEATURES.f01, },
    { tag: 'f32', x: 66, y: 152, data: FEATURES.f32, },
    { tag: 'f30', x: -50, y: 34, data: FEATURES.f30, },
    { tag: 'f18', x: 89, y: -119, data: FEATURES.f18, },
    { tag: 'f19', x: -8, y: -93, data: FEATURES.f19, },
    { tag: 'f14', x: -298, y: -93, data: FEATURES.f14, },
    { tag: 'f22', x: -66, y: 131, data: FEATURES.f22, desktoponly: true, },
    { tag: 'f23', x: -181, y: 65, data: FEATURES.f23, desktoponly: true, },
    { tag: 'f21', x: -199, y: -25, data: FEATURES.f21, desktoponly: true, },
    { tag: 'f13', x: 51, y: -7, data: FEATURES.f13, desktoponly: true, },
  ],
  "ready_made_feature_trike_closed_1": [
    { tag: 'f01', x: 276, y: 99, data: FEATURES.f01, },
    { tag: 'f03', x: 226, y: 24, data: FEATURES.f03, },
    { tag: 'f05', x: 324, y: -23, data: FEATURES.f05, },
    { tag: 'f07', x: 234, y: -96, data: FEATURES.f07, },
    { tag: 'f05', x: 305, y: -137, data: FEATURES.f05, },
    { tag: 'f04', x: 129, y: 64, data: FEATURES.f04, },
    { tag: 'f20', x: 147, y: -114, data: FEATURES.f20, },
    { tag: 'f12', x: -8, y: -119, data: FEATURES.f12, },
    { tag: 'f17', x: -54, y: 21, data: FEATURES.f17, },
    { tag: 'f32', x: -191, y: 168, data: FEATURES.f32, },
    { tag: 'f10', x: -153, y: -109, data: FEATURES.f10, },
    { tag: 'f11', x: -210, y: -140, data: FEATURES.f11, },
    { tag: 'f22', x: -287, y: 121, data: FEATURES.f22, desktoponly: true, },
    { tag: 'f13', x: -239, y: 10, data: FEATURES.f13, desktoponly: true, },
    { tag: 'f14', x: -380, y: -46, data: FEATURES.f14, desktoponly: true, },
    { tag: 'f09', x: -209, y: -79, data: FEATURES.f09, desktoponly: true, },
    { tag: 'f15', x: -77, y: -50, data: FEATURES.f15, desktoponly: true, },
  ],
  "ready_made_feature_trike_open_1": [
    { tag: 'f01', x: 276, y: 99, data: FEATURES.f01, },
    { tag: 'f03', x: 226, y: 24, data: FEATURES.f03, },
    { tag: 'f05', x: 324, y: -23, data: FEATURES.f05, },
    { tag: 'f07', x: 234, y: -96, data: FEATURES.f07, },
    { tag: 'f05', x: 305, y: -137, data: FEATURES.f05, },
    { tag: 'f04', x: 129, y: 64, data: FEATURES.f04, },
    { tag: 'f20', x: 147, y: -114, data: FEATURES.f20, },
    { tag: 'f32', x: -60, y: 169, data: FEATURES.f32, },
    { tag: 'f22', x: -148, y: 151, data: FEATURES.f22, },
    { tag: 'f30', x: -148, y: 90, data: FEATURES.f30, },
    { tag: 'f15', x: -78, y: -50, data: FEATURES.f15, },
    { tag: 'f09', x: -179, y: -98, data: FEATURES.f09, },
    { tag: 'f23', x: -268, y: 69, data: FEATURES.f23, desktoponly: true, },
    { tag: 'f14', x: -363, y: -45, data: FEATURES.f14, desktoponly: true, },
    { tag: 'f13', x: -99, y: 15, data: FEATURES.f13, desktoponly: true, },
    { tag: 'f11', x: -208, y: -143, data: FEATURES.f11, desktoponly: true, },
    { tag: 'f10', x: -147, y: -120, data: FEATURES.f10, desktoponly: true, },
    { tag: 'f12', x: 14, y: -120, data: FEATURES.f12, desktoponly: true, },
  ],
  "ready_made_feature_boat_closed_1": [
    { tag: 'f01', x: 189, y: 140, data: FEATURES.f01, },
    { tag: 'f20', x: 174, y: -139, data: FEATURES.f20, },
    { tag: 'f17', x: -50, y: 30, data: FEATURES.f17, },
    { tag: 'f15', x: -78, y: -55, data: FEATURES.f15, },
    { tag: 'f32', x: -193, y: 170, data: FEATURES.f32, },
    { tag: 'f19', x: -165, y: -56, data: FEATURES.f19, },
    { tag: 'f18', x: -247, y: -80, data: FEATURES.f18, },
    { tag: 'f22', x: -280, y: 113, data: FEATURES.f22, desktoponly: true, },
    { tag: 'f13', x: -240, y: 6, data: FEATURES.f13, desktoponly: true, },
    { tag: 'f14', x: -367, y: -37, data: FEATURES.f14, desktoponly: true, },
  ],
  "ready_made_feature_boat_open_1": [
    { tag: 'f01', x: 189, y: 140, data: FEATURES.f01, },
    { tag: 'f20', x: 174, y: -139, data: FEATURES.f20, },
    { tag: 'f15', x: -78, y: -55, data: FEATURES.f15, },
    { tag: 'f32', x: -61, y: 162, data: FEATURES.f32, },
    { tag: 'f13', x: -83, y: 16, data: FEATURES.f13, },
    { tag: 'f19', x: -177, y: -54, data: FEATURES.f19, },
    { tag: 'f18', x: -233, y: -81, data: FEATURES.f18, },
    { tag: 'f22', x: -145, y: 150, data: FEATURES.f22, },
    { tag: 'f30', x: -150, y: 80, data: FEATURES.f30, },
    { tag: 'f23', x: -282, y: 68, data: FEATURES.f23, desktoponly: true, },
    { tag: 'f14', x: -370, y: -43, data: FEATURES.f14, desktoponly: true, },
    { tag: 'f17', x: 71, y: 15, data: FEATURES.f17, desktoponly: true, },
  ],
  "ready_made_feature_trike_closed_2": [
    { tag: 'f01', x: 184, y: 115, data: FEATURES.f01, },
    { tag: 'f02', x: 280, y: 100, data: FEATURES.f02, },
    { tag: 'f04', x: 112, y: 54, data: FEATURES.f04, },
    { tag: 'f08', x: 266, y: 5, data: FEATURES.f08, },
    { tag: 'f07', x: 194, y: -128, data: FEATURES.f07, },
    { tag: 'f05', x: 275, y: -182, data: FEATURES.f05, },
    { tag: 'f20', x: 93, y: -149, data: FEATURES.f20, },
    { tag: 'f31', x: 20, y: -41, data: FEATURES.f31, },
    { tag: 'f16', x: -81, y: 14, data: FEATURES.f16, },
    { tag: 'f12', x: -93, y: -124, data: FEATURES.f12, },
    { tag: 'f11', x: -198, y: -98, data: FEATURES.f11, },
    { tag: 'f10', x: -254, y: -130, data: FEATURES.f10, },
    { tag: 'f32', x: -232, y: 178, data: FEATURES.f32, },
    { tag: 'f13', x: -289, y: 17, data: FEATURES.f13, },
    { tag: 'f03', x: 209, y: 32, data: FEATURES.f03, desktoponly: true, },
  ],
  "ready_made_feature_trike_open_2": [
    { tag: 'f01', x: 184, y: 115, data: FEATURES.f01, },
    { tag: 'f02', x: 280, y: 100, data: FEATURES.f02, },
    { tag: 'f04', x: 112, y: 54, data: FEATURES.f04, },
    { tag: 'f08', x: 236, y: 15, data: FEATURES.f08, },
    { tag: 'f07', x: 194, y: -128, data: FEATURES.f07, },
    { tag: 'f05', x: 275, y: -182, data: FEATURES.f05, },
    { tag: 'f20', x: 93, y: -149, data: FEATURES.f20, },
    { tag: 'f17', x: -33, y: 14, data: FEATURES.f17, },
    { tag: 'f32', x: -136, y: 179, data: FEATURES.f32, },
    { tag: 'f30', x: -188, y: 94, data: FEATURES.f30, },
    { tag: 'f15', x: -132, y: -85, data: FEATURES.f15, },
    { tag: 'f09', x: -234, y: -109, data: FEATURES.f09, },
    { tag: 'f08', x: 266, y: 5, data: FEATURES.f08, desktoponly: true, },
    { tag: 'f13', x: -178, y: 24, data: FEATURES.f13, desktoponly: true, },
    { tag: 'f11', x: -240, y: -144, data: FEATURES.f11, desktoponly: true, },
    { tag: 'f10', x: -205, y: -110, data: FEATURES.f10, desktoponly: true, },
    { tag: 'f03', x: -81, y: -108, data: FEATURES.f03, desktoponly: true, },
  ],
  "ready_made_feature_boat_closed_2": [
    { tag: 'f01', x: 129, y: 153, data: FEATURES.f01, },
    { tag: 'f31', x: 16, y: -38, data: FEATURES.f31, },
    { tag: 'f16', x: -72, y: 16, data: FEATURES.f16, },
    { tag: 'f15', x: -156, y: -65, data: FEATURES.f15, },
    { tag: 'f32', x: -225, y: 166, data: FEATURES.f32, },
    { tag: 'f13', x: -283, y: 18, data: FEATURES.f13, },
    { tag: 'f19', x: -250, y: -62, data: FEATURES.f19, },
    { tag: 'f18', x: -350, y: -67, data: FEATURES.f18, },
    { tag: 'f17', x: -13, y: 27, data: FEATURES.f17, desktoponly: true, },
  ],
  "ready_made_feature_boat_open_2": [
    { tag: 'f01', x: 129, y: 153, data: FEATURES.f01, },
    { tag: 'f17', x: -34, y: 5, data: FEATURES.f17, },
    { tag: 'f32', x: -131, y: 169, data: FEATURES.f32, },
    { tag: 'f30', x: -193, y: 97, data: FEATURES.f30, },
    { tag: 'f15', x: -151, y: -63, data: FEATURES.f15, },
    { tag: 'f19', x: -261, y: -49, data: FEATURES.f19, },
    { tag: 'f18', x: -326, y: -70, data: FEATURES.f18, },
  ],
  "ready_made_feature_camper_closed_0": [
    { tag: 'f01', x: 276, y: 214, data: FEATURES.f01, },
    { tag: 'f02', x: 204, y: 223, data: FEATURES.f02, },
    { tag: 'f03', x: 243, y: 135, data: FEATURES.f03, },
    { tag: 'f04', x: 168, y: 143, data: FEATURES.f04, },
    { tag: 'f05', x: 259, y: 22, data: FEATURES.f05, },
    { tag: 'f31', x: 83, y: 38, data: FEATURES.f31, },
    { tag: 'f12', x: 70, y: -94, data: FEATURES.f12, },
    { tag: 'f30', x: -80, y: 144, data: FEATURES.f30, },
    { tag: 'f32', x: -151, y: 110, data: FEATURES.f32, },
    { tag: 'f22', x: -270, y: 129, data: FEATURES.f22, },
    { tag: 'f23', x: -244, y: 39, data: FEATURES.f23, },
    { tag: 'f24', x: -238, y: -65, data: FEATURES.f24, },
    { tag: 'f14', x: -344, y: -99, data: FEATURES.f14, },
    { tag: 'f10', x: -40, y: -166, data: FEATURES.f10, },
    { tag: 'f11', x: -111, y: -204, data: FEATURES.f11, },
    { tag: 'f13', x: -130, y: -59, data: FEATURES.f13, desktoponly: true, },
    { tag: 'f09', x: -93, y: -167, data: FEATURES.f09, desktoponly: true, },
    { tag: 'f15', x: 26, y: -84, data: FEATURES.f15, desktoponly: true, },
  ],
  "ready_made_feature_camper_open_0": [
    { tag: 'f01', x: 276, y: 214, data: FEATURES.f01, },
    { tag: 'f02', x: 204, y: 223, data: FEATURES.f02, },
    { tag: 'f03', x: 243, y: 135, data: FEATURES.f03, },
    { tag: 'f05', x: 259, y: 22, data: FEATURES.f05, },
    { tag: 'f32', x: 23, y: 148, data: FEATURES.f32, },
    { tag: 'f30', x: -100, y: 72, data: FEATURES.f30, },
    { tag: 'f13', x: 14, y: -14, data: FEATURES.f13, },
    { tag: 'f15', x: 32, y: -102, data: FEATURES.f15, },
    { tag: 'f09', x: -76, y: -170, data: FEATURES.f09, },
    { tag: 'f25', x: -109, y: -29, data: FEATURES.f25, },
    { tag: 'f28', x: -171, y: -48, data: FEATURES.f28, },
    { tag: 'f14', x: -344, y: -99, data: FEATURES.f14, },
    { tag: 'f22', x: -133, y: 123, data: FEATURES.f22, desktoponly: true, },
    { tag: 'f23', x: -261, y: 59, data: FEATURES.f23, desktoponly: true, },
    { tag: 'f21', x: -247, y: -17, data: FEATURES.f21, desktoponly: true, },
    { tag: 'f11', x: -104, y: -216, data: FEATURES.f11, desktoponly: true, },
    { tag: 'f10', x: -37, y: -173, data: FEATURES.f10, desktoponly: true, },
    { tag: 'f12', x: 79, y: -92, data: FEATURES.f12, desktoponly: true, },
  ],
  "ready_made_feature_camper_closed_1": [
    { tag: 'f01', x: 327, y: 93, data: FEATURES.f01, },
    { tag: 'f02', x: 268, y: 155, data: FEATURES.f02, },
    { tag: 'f03', x: 262, y: 50, data: FEATURES.f03, },
    { tag: 'f05', x: 274, y: -93, data: FEATURES.f05, },
    { tag: 'f31', x: 62, y: -13, data: FEATURES.f31, },
    { tag: 'f16', x: -57, y: 2, data: FEATURES.f16, },
    { tag: 'f17', x: -60, y: 82, data: FEATURES.f17, },
    { tag: 'f12', x: 3, y: -136, data: FEATURES.f12, },
    { tag: 'f30', x: -164, y: 106, data: FEATURES.f30, },
    { tag: 'f32', x: -255, y: 70, data: FEATURES.f32, },
    { tag: 'f22', x: -330, y: 132, data: FEATURES.f22, },
    { tag: 'f13', x: -263, y: -63, data: FEATURES.f13, },
    { tag: 'f10', x: -153, y: -160, data: FEATURES.f10, },
    { tag: 'f11', x: -210, y: -179, data: FEATURES.f11, },
    { tag: 'f09', x: -209, y: -149, data: FEATURES.f09, desktoponly: true, },
    { tag: 'f15', x: -88, y: -128, data: FEATURES.f15, desktoponly: true, },
  ],
  "ready_made_feature_camper_open_1": [
    { tag: 'f01', x: 327, y: 93, data: FEATURES.f01, },
    { tag: 'f02', x: 268, y: 155, data: FEATURES.f02, },
    { tag: 'f03', x: 262, y: 50, data: FEATURES.f03, },
    { tag: 'f05', x: 274, y: -93, data: FEATURES.f05, },
    { tag: 'f04', x: 192, y: 54, data: FEATURES.f04, },
    { tag: 'f30', x: -4, y: 115, data: FEATURES.f30, },
    { tag: 'f32', x: -99, y: 64, data: FEATURES.f32, },
    { tag: 'f15', x: -81, y: -135, data: FEATURES.f15, },
    { tag: 'f09', x: -193, y: -165, data: FEATURES.f09, },
    { tag: 'f28', x: -258, y: -66, data: FEATURES.f28, },
    { tag: 'f25', x: -233, y: -15, data: FEATURES.f25, },
    { tag: 'f27', x: -235, y: 45, data: FEATURES.f27, },
    { tag: 'f29', x: -173, y: 0, data: FEATURES.f29, },
    { tag: 'f13', x: -120, y: -69, data: FEATURES.f13, desktoponly: true, },
    { tag: 'f17', x: 81, y: -65, data: FEATURES.f17, desktoponly: true, },
    { tag: 'f11', x: -180, y: -192, data: FEATURES.f11, desktoponly: true, },
    { tag: 'f10', x: -158, y: -160, data: FEATURES.f10, desktoponly: true, },
    { tag: 'f12', x: -20, y: -138, data: FEATURES.f12, desktoponly: true, },
  ],
  "ready_made_feature_camper_closed_2": [
    { tag: 'f01', x: 302, y: -2, data: FEATURES.f01, },
    { tag: 'f05', x: 249, y: -181, data: FEATURES.f05, },
    { tag: 'f04', x: 153, y: 18, data: FEATURES.f04, },
    { tag: 'f31', x: 39, y: -28, data: FEATURES.f31, },
    { tag: 'f16', x: -68, y: 18, data: FEATURES.f16, },
    { tag: 'f17', x: -19, y: 114, data: FEATURES.f17, },
    { tag: 'f30', x: -152, y: 159, data: FEATURES.f30, },
    { tag: 'f32', x: -282, y: 159, data: FEATURES.f32, },
    { tag: 'f13', x: -305, y: 37, data: FEATURES.f13, },
    { tag: 'f17', x: -254, y: -60, data: FEATURES.f17, },
    { tag: 'f10', x: -188, y: -100, data: FEATURES.f10, },
    { tag: 'f12', x: -58, y: -115, data: FEATURES.f12, },
    { tag: 'f02', x: 285, y: 65, data: FEATURES.f02, desktoponly: true, },
    { tag: 'f09', x: -228, y: -60, data: FEATURES.f09, desktoponly: true, },
    { tag: 'f15', x: -138, y: -79, data: FEATURES.f15, desktoponly: true, },
  ],
  "ready_made_feature_camper_open_2": [
    { tag: 'f01', x: 302, y: -2, data: FEATURES.f01, },
    { tag: 'f05', x: 249, y: -181, data: FEATURES.f05, },
    { tag: 'f04', x: 153, y: 18, data: FEATURES.f04, },
    { tag: 'f17', x: 90, y: 72, data: FEATURES.f17, },
    { tag: 'f30', x: -21, y: 120, data: FEATURES.f30, },
    { tag: 'f15', x: -147, y: -83, data: FEATURES.f15, },
    { tag: 'f09', x: -227, y: -78, data: FEATURES.f09, },
    { tag: 'f32', x: -137, y: 111, data: FEATURES.f32, },
    { tag: 'f26', x: -257, y: 70, data: FEATURES.f26, },
    { tag: 'f28', x: -196, y: 79, data: FEATURES.f28, },
    { tag: 'f25', x: -216, y: 16, data: FEATURES.f25, },
    { tag: 'f27', x: -196, y: 128, data: FEATURES.f27, desktoponly: true, },
    { tag: 'f13', x: -172, y: -9, data: FEATURES.f13, desktoponly: true, },
    { tag: 'f11', x: -259, y: -44, data: FEATURES.f11, desktoponly: true, },
    { tag: 'f10', x: -196, y: -93, data: FEATURES.f10, desktoponly: true, },
    { tag: 'f12', x: -84, y: -114, data: FEATURES.f12, desktoponly: true, },
    { tag: 'f02', x: 288, y: 58, data: FEATURES.f02, desktoponly: true, },
  ],
}

